module.exports = __webpack_public_path__ + "static/media/scalable_ruler.18ee395f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Twitch/Preview/img/scalable_ruler.mp4
// module id = 221
// module chunks = 0